import { render, staticRenderFns } from "./MainMenuDev.vue?vue&type=template&id=47425cf1"
import script from "./MainMenuDev.vue?vue&type=script&lang=js"
export * from "./MainMenuDev.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports